<template>
  <div>
    <v-form ref="attributeForm" v-model="formValid">
    <box class="main-top-margin">
      <v-row dense>
        <v-col cols="12" class="px-4 py-6">
          <div v-if="isLoading" class="text-center ma-12">
              <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
          </div>

          <template v-else>
            <template v-if="this.item.isCustom || !this.item.id">
              <SubHeader :text="$t('ATTRIBUTE-LABELS')" small />
              <v-row dense class="">
                <v-col cols="4" v-for="language in languages" :key="language.id">
                  <v-text-field
                    :label="$t(`ATTRIBUTE-LABEL-NAME-${language.shortcode.toUpperCase()}`)"
                    v-model="item.displayName[language.shortcode.toLowerCase()]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          <BoxItem
                  v-if="item.id"
                    :title="$t('ATTRIBUTE-LABEL-NAME')"
                    :value="item.name"
                    required
                    :readOnly="true"
                    showRequiredSymbol
                    :rules="[rules.required, rules.name]"
                    @updateValue="item.name = $event"
                  />

          <v-row dense>
            <v-col cols="6">
              <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-UNIT')"
                    :value="item.unit"
                    :items="units"
                    @updateValue="item.unit = $event"
                  />
              <!-- <v-select
                :label="$t('ATTRIBUTE-LABEL-UNIT')"
                v-model="item.unit"
                :items="units"
              ></v-select> -->
            </v-col>

            <v-col cols="6">
              <template v-if="item.type === 'image'">
                <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-TYPE')"
                    :value="$t('ATTRIBUTE_DATATYPE_IMAGE')"
                    readOnly
                  />  
              </template>
              <BoxItem
                    v-else
                    :title="$t('ATTRIBUTE-LABEL-TYPE')"
                    :value="item.type"
                    :items="types"
                    required
                     style="z-index: 100;"
                    showRequiredSymbol
                    :rules="[rules.required]"
                    itemsValue="value"
                    itemsText="label"
                    @updateValue="item.type = $event"
                  />
            </v-col>
            <template v-if="['integer', 'number', 'string'].includes(item.type)">
              <v-col cols="6">
                <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-CONSTRAINT-MIN')"
                    :value="constraints.min"
                    type="number"
                    @updateValue="constraints.min = $event"
                  />
            </v-col>
            <v-col cols="6">
                <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-CONSTRAINT-MAX')"
                    :value="constraints.max"
                    type="number"
                    @updateValue="constraints.max = $event"
                  />
            </v-col>  
            </template>
            <v-col cols="12" v-if="item.type === 'string'">
              <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-CONSTRAINT-PATTERN')"
                    :value="constraints.pattern"
                    @updateValue="constraints.pattern = $event"
                  />
            </v-col>            
            <v-col cols="12" v-if="item.type === 'enum'">
              <SubHeader :text="$t('ATTRIBUTE-LABEL-ENUM-OPTIONS')" small />
                <ul v-if="enumOptions" class="enum-options-list">
                  <li v-for="(option, index) in enumOptions" :key="index">
                    <BoxItem
                    :value="option"
                    @updateValue="enumOptions.splice(index, 1,$event)"
                  />
                  <v-btn small text @click="removeEnumOption(index)">
                    <v-icon color="#404046">mdi-minus</v-icon>
                  </v-btn>
                  </li>
                </ul>

                <div>
                  <v-btn small text @click="addNewEnumValue">
                    <v-icon color="#404046">mdi-plus</v-icon>
                  </v-btn>
                </div>
            </v-col>
              <v-col cols="6">
              <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-OWNER')"
                    :value="item.owner"
                    :items="owners"
                    itemsValue="value"
                     style="z-index: 100;"
                    itemsText="label"
                    @updateValue="item.owner = $event"
                  />
            </v-col>
            <v-col cols="6" v-if="item && item.isCustom">
              <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-CALCULATION_RULE')"
                    :value="item.calculationrule_id"
                    :items="calculationRules"
                    itemsValue="id"
                    clearable
                    style="z-index: 100;"
                    itemsText="name"
                    @updateValue="item.calculationrule_id = $event"
                  />
            </v-col>
            <v-col cols="6">
              <AttributeDefaultValue :item="item" :constraints="constraints" :enumOptions="enumOptions" @updateDefaultValue="item.defaultValue = $event" @invalidField="invalidDefaultValue"/>
            </v-col>   
            <v-col cols="12" v-if="(item.isSymbol && item.id) || (item.id && item.isCustom && item.type ==='boolean' && !item.isValueChain)">
              <v-row align="end" class="ma-0 mb-5 pa-0 file-wrapper">
                  <v-file-input
                    accept="image/png, image/jpeg"
                    :placeholder="$t('GLOBAL-FILE_UPLOAD-CHOOSE_FILE')"
                    type="file"
                    ref="fileUploader"
                    prepend-icon=""
                    :clearable="false"
                    :label="$t('ATTRIBUTE-IMAGE_UPLOAD')"
                    :loading="isUploading ? 'green' : false"
                    :disabled="isUploading || !canModifyImage"
                    @change="imageUpload($event)"
                    @click:clear="imageRemove"
                    :key="editedItem"
                  >
                  </v-file-input>
                  <v-icon style="position: absolute; right: 0; bottom: 24px;" @click="triggerFileUpload">mdi-upload</v-icon>
                  <v-sheet
                    :key="editedItem"
                    color="grey lighten-3"
                    width="88px"
                    height="46px"
                    class="ml-4 clickable"
                    @click="triggerFileUpload"
                    style="position: absolute; right: 22px; bottom: 26px; z-index: 10; width: 88px; height: 46px; display: flex; align-items: center;"
                  >
                    <v-btn
                      v-if="item.imageUrl != null && canModifyImage"
                      fab
                      plain
                      x-small
                      absolute
                      style="z-index: 999; width: 18px; height: 18px; right: -6px; top: -6px;"
                      @click.stop="imageRemove()"
                    >
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>

                    <v-img max-height="28px" contain :src="item.imageUrl">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular size="16" width="2" indeterminate color="grey darken-3"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-sheet>
                </v-row>

            </v-col>
            <v-col cols="12" v-if="item && item.isValueChain && !item.isCustom">
              <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-VALUE-CHAIN-SECTION')"
                    :value="item.valueChainSection"
                    :items="valueChainSections"
                    itemsValue="value"
                    itemsText="label"
                    @updateValue="item.valueChainSection = $event"
                  />
            </v-col>           
            

            <v-col class="d-flex flex-column">
              <div class="list-item">
                <v-switch v-model="item.isHostAttribute"  class="mr-2"/>
                <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_HOST_ATTRIBUTE')" small />
              </div> 
              <div class="list-item">
                <v-switch v-model="item.syncWithKiSoft"  class="mr-2" />
                <SubHeader :text="$t('ATTRIBUTE-LABEL-SYNC_WITH_KISOFT')" small />
              </div>
              <div class="list-item">
                <v-switch v-model="item.isWritable"  class="mr-2"/>
                <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_WRITEABLE')" small />
              </div>
              <div class="list-item">
                <v-switch v-model="item.isExportable"  class="mr-2"/>
                <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_EXPORTABLE')" small />
              </div>
              <div class="list-item">
                <v-switch v-model="item.isImportable"  class="mr-2"/>
                <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_IMPORTABLE')" small />
              </div>
              <div class="list-item">
                <v-switch v-model="item.isSymbol"  class="mr-2"/>
                <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_SYMBOL')" small />
              </div>
                <div class="list-item">
                  <v-switch v-model="item.isMandatory"  class="mr-2"/>
                  <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_MANDATORY')" small />
                </div>
                <div class="list-item">
                  <v-switch v-model="item.isValueChain"  class="mr-2"/>
                  <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_VALUE_CHAIN')" small />
                </div>
                <div class="list-item" v-if="item.isValueChain">
                  <BoxItem
                    :title="$t('ATTRIBUTE-VALUE-CHAIN-NAME')"
                    :value="item.valueChainName"
                    @updateValue="item.valueChainName = $event"
                  />
                </div>
                <div class="list-item" v-if="item.id">
                  <v-switch v-model="item.isActive"  class="mr-2"/>
                  <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_ACTIVE')" small />
                </div>
                <div class="list-item" v-if="item.id">
                  <v-switch v-model="item.isCustom"  class="mr-2" readonly />
                  <SubHeader :text="$t('ATTRIBUTE-LABEL-IS_CUSTOM')" small />
                </div>
            </v-col>

          

            <v-col>
            </v-col>
          </v-row>
          </template>
        
        </v-col>
      </v-row>
      
    </box>
  </v-form>
    <box class="mt-2" background="transparent" borderColor="transparent" padding="1em 0">
    
    <div class="d-flex justify-end">
        <v-btn color="secondary" :loading="isSaving" :disabled="!formValid"  bottom right  @click="save" style="z-index:999;">
            <small><lang t="GLOBAL-BTN-SAVE" /></small>
          </v-btn>
    </div>

</box>
  </div>
</template>

<script>
import Box from "../../../components/ui-elements/Box.vue";
import BoxItem from '../../../components/ui-elements/BoxItem.vue';
import SubHeader from "../../../components/ui-elements/SubHeader.vue";
import AttributeDefaultValue from './AttributeDefaultValue.vue';
import {cloneDeep} from 'lodash';

  export default {
    name: 'Attribute',
    data(){
      return {
        item: {
          name: null,
          unit: null,
          type: null,
          displayName: {},
          defaultValue: null,
          isHostAttribute: false,
          syncWithKiSoft: false,
          isWritable: false, 
          imageUrl: null,
          image: null
        },
        constraints: {
          min: null,
          max: null,
          pattern: null
        },
        calculationRules: [],
        isLoading: false,
        isSaving: false,
        isUploading: false,
        enumOptions: [],
        formValid: false
      }
    },
    components:{
      Box, BoxItem, SubHeader, AttributeDefaultValue
    },
    watch:{
      'item.type': {
        handler: function(newValue, oldValue){
          if(newValue !== oldValue && oldValue)
            this.item.defaultValue = null;
        },
        deep: true
      },
      'item.isSymbol':{
        handler: function(newValue, oldValue){
          if(!newValue) return;
          this.item.type = 'boolean'; 
        },
        deep: true
      }
    },
    computed: {
      canModifyImage(){
        return ((this.item.isSymbol && this.item.id > 0) || (this.item.id > 0 && this.item.isCustom && !this.item.isValueChain && this.item.type === 'boolean')) && (!this.item.imageUrl || (this.item.imageUrl && this.item.image));
      },
      
      units() {
        return ["mm", "g"];
      },
      
      isBundleAttribute(){
        return this.$store.getters.isBundleAttribute;
      },
      types() {
        return [{value: "number", label: this.$i18n.t("ATTRIBUTE_DATATYPE_NUMBER")},
        {value: "enum", label: this.$i18n.t("ATTRIBUTE_DATATYPE_ENUM")},
        {value: "string", label: this.$i18n.t("ATTRIBUTE_DATATYPE_STRING")},
        {value: "boolean", label: this.$i18n.t("ATTRIBUTE_DATATYPE_BOOLEAN")},
        {value: "date", label: this.$i18n.t("ATTRIBUTE_DATATYPE_DATE")},
        {value: "integer", label: this.$i18n.t("ATTRIBUTE_DATATYPE_INTEGER")},
        // {value: "image", label: this.$i18n.t("ATTRIBUTE_DATATYPE_IMAGE")}
      ];
      },
      owners(){
        return [
          {value: 'HOST', label: this.$i18n.t('ATTRIBUTE-OWNER-HOST')},
          {value: 'BG', label: this.$i18n.t('ATTRIBUTE-OWNER-BG')},
          {value: 'SITE', label: this.$i18n.t('ATTRIBUTE-OWNER-SITE')},
        ]
      },
      valueChainSections(){
        return [
          {value: 'CORE', label: this.$i18n.t('ATTRIBUTE-VALUE-CHAIN-CORE')},
          {value: 'EXTENSION', label: this.$i18n.t('ATTRIBUTE-VALUE-CHAIN-EXTENSION')},
          {value: 'NESTING', label: this.$i18n.t('ATTRIBUTE-VALUE-CHAIN-NESTING')},
          {value: 'DIMENSIONS', label: this.$i18n.t('ATTRIBUTE-VALUE-CHAIN-DIMENSIONS')},
          {value: 'ADP', label: this.$i18n.t('ATTRIBUTE-VALUE-CHAIN-ADP')}
        ]
      },
      currentLangShortCode() {
        return this.$store.getters.langShortcode;
      },
      languages() {
          return this.$store.state.languages;
        }
  }, 
  created(){
    this.initialize();
    if(this.$refs.attributeForm){
      this.$refs.attributeForm.validate();
    }
  },
  methods: {
    invalidDefaultValue(isInvalid){
      if(isInvalid){
        this.formValid = false;
      }
    },

    triggerFileUpload(){
        if(this.$refs.fileUploader && this.$refs.fileUploader.$el){ 
          const fileUploader = this.$refs.fileUploader.$el.querySelector('input');
          if(fileUploader) fileUploader.click();
        }
    },

    imageRemove() {
      this.item.imageUrl = null;
      this.item.image = null;
    },

    imageUpload(file) {
      if (typeof file == "undefined" || file == null) {
        return false;
      }

      this.isUploading = true;

      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");
      formData.append('attribute_id', this.item.id);

      this.axios
        .post("/upload", formData)
        .then((response) => {

          this.item.imageUrl = response.data.url;
          this.item.image = response.data.filename;
          setTimeout(() => {
            this.isUploading = false;
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
        });
    },

      async initialize(){
        this.isLoading = true;
        this.axios.get("calculationrules").then((res) => {
              this.calculationRules = res.data.sort((a,b) => {
                const aName = String(a.name);
                const bName = String(b.name);
                return aName.localeCompare(bName);
              });
            });
        if (!this.$route.params?.id) {
            this.item.isCustom = true;
            for(const language of this.languages){
                this.item.displayName[language.shortcode.toLowerCase()] = '';
            }
          // item does not exists yet
        }else{
          //item exists
          try{
            const output = await this.axios.get(`attributes/${this.$route.params.id}`);
            if(output){
              this.item = cloneDeep(output.data);
              if(this.item.settings && this.item.settings.options){
                this.enumOptions = [...this.item.settings.options];
              }
              if(this.item.settings && this.item.settings.min !== undefined && this.item.settings.min !== null){
                this.constraints.min = this.item.settings.min;
              }

              if(this.item.settings && this.item.settings.max !== undefined && this.item.settings.max !== null){
                this.constraints.max = this.item.settings.max;
              }

              if(this.item.settings && this.item.settings.pattern !== undefined && this.item.settings.pattern !== null){
                this.constraints.pattern = this.item.settings.pattern;
              }
            }
          }catch(err){
            console.error(err);
          }
        }
        this.changeTitle();
        this.isLoading = false;
      },
      changeTitle() {
        let displayName = '';

        
        let label = '';
        
        
        if(this.item.id){
            if(this.item.displayName[this.currentLangShortCode]){
              displayName = this.item.displayName[this.currentLangShortCode];
            }
            let name = this.item.name;
            if(this.item.valueChainName && this.item.valueChainName.length > 0 && this.item.isValueChain){
              name = this.item.valueChainName;
            }
            this.$route.meta.pageTitle =  `${label} ${displayName} (${name})`
        }else{
          if(this.item.isCustom){
            if(this.isBundleAttribute){
              this.$route.meta.pageTitle = this.$t("NEW_BUNDLE_CUSTOM_ATTRIBUTE");
            }else{
              this.$route.meta.pageTitle = this.$t("NEW_ITEM_CUSTOM_ATTRIBUTE");
            }
          }
          
      
        }

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },
    save() {
      
      this.$refs.attributeForm.validate();
      if(!this.formValid)return;
      this.isSaving = true;
      if(this.enumOptions && this.enumOptions.length > 0){
        this.item = Object.assign(this.item, {settings: {...this.item.settings, options: [...this.enumOptions]}});
      }

      if(!this.item.isValueChain && this.item.valueChainName){
          this.item.valueChainName = '';
      }

      if(["number", "string", "integer"].includes(this.item.type)){
      if(!this.item.settings){
        this.item.settings = {};
      } 
      this.item.settings = Object.assign(this.item.settings, {...this.constraints});
    }

      if (!this.item.id) {
        this.prepareNewItemBasedOnType();
        this.axios.post("attributes", this.item).then((res) => {
            this.isSaving = false;
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
            });
            this.$router.push({name: 'settings-attributes-item', params: {id: res.data.id}});
            this.initialize();
        });
      } else {
        this.axios
          .put("attributes/" + this.item.id, this.item)
          .then((res) => {
              this.isSaving = false;
              this.$store.dispatch("setSnackbar", {
                text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
              });
              this.changeTitle();
          });
      }
    },
    prepareNewItemBasedOnType(){
      if(this.item.id > 0) return; // do nothing when working with already existing attribute
      if(this.isBundleAttribute){
        this.item.isBundleAttribute = true;
        this.item.isItemAttribute = false;
      }else{
        this.item.isBundleAttribute = false;
        this.item.isItemAttribute = true;
      }
    },
    addNewEnumValue(){
      this.enumOptions.push('');
    },
    removeEnumOption(index){
      this.enumOptions.splice(index, 1);
    }

  }
}
</script>

<style lang="scss" scoped>
  .list-item{
    display: flex;
    align-items: center;
    height: 40px;
    min-width: 400px;
    padding-top: 10px;
  }

  .enum-options-list{
    list-style: none;
    padding: 0;
    & li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > div:first-of-type{
        flex: 1;
      }
    }
  }
  .file-wrapper{
    position: relative;
  }
</style>
